import type { TableColumn } from '@shared/components/data-table/data-table.component';
import type { FormFieldConfig } from '@shared/components/search-form/search-form.component';

export interface PackageWarehouseStock {
  id: number;
  code: string;
  name: string;
}

export interface PackageInventoryItem {
  id: string;
  skuCode: string;
  skuName: string;
  spuCode: string;
  spuName: string;
  fulfillmentMode?: string;
  availableQty: number;
  lastUpdateDate?: string;
  warehouses: PackageWarehouseStock[];
}

export const PACKAGE_INVENTORY_SEARCH_CONFIG: FormFieldConfig[] = [
  {
    key: 'skuCode',
    label: 'package_operation.filters.package_sku',
    type: 'text',
    placeholder: 'package_operation.filters.package_sku',
  },
  {
    key: 'skuName',
    label: 'package_operation.filters.package_sku_name',
    type: 'text',
    placeholder: 'package_operation.filters.package_sku_name',
  },
];

export const PACKAGE_INVENTORY_COLUMNS: TableColumn[] = [
  {
    label: 'package_operation.table.package_sku',
    prop: 'skuCode',
    width: 170,
  },
  {
    label: 'package_operation.table.package_sku_name',
    prop: 'skuName',
    width: 190,
  },
  {
    label: 'package_operation.table.fulfillment_mode',
    prop: 'fulfillmentMode',
    type: 'custom',
    width: 150,
  },
  {
    label: 'package_operation.table.available_qty',
    prop: 'availableQty',
    type: 'custom',
    align: 'right',
    width: 100,
  },
  {
    label: 'package_operation.table.latest_updated',
    prop: 'lastUpdateDate',
    type: 'custom',
    width: 155,
  },
  {
    label: 'package_operation.table.actions',
    prop: 'actions',
    type: 'actions',
    width: 160,
  },
];
